import styled from 'styled-components';

export default styled.div`

    width: 100%;
    align-self: flex-end;

    .appFooter {
        padding-top: 2rem;
        padding-bottom: 2rem;
        .brand {
            color: #ED616E;
        }
        .adress {
            margin-bottom: 0;
        }
        .socialIcons {
            margin: 20px 10px 0 0;
            color: black;
            &:hover {
                color: #016AE8;
            }
        }
    }

`
